// convert a number to a string with one decimal point
// 79 => 7.9
export const numberToTenths = (value: number): string => {
  return (value / 10).toFixed(1);
};
